import * as TabsPrimitive from '@radix-ui/react-tabs';
import classNames from 'classnames';
import { isEmpty } from 'lodash';

import type { TabsProps } from './types';

import './tabs.scss';

export const Tabs = ({
  className,
  label,
  tabs = [],
  variant = 'regular',
  value,
  onValueChange,
  disableTabs,
  disableContent,
}: TabsProps) => {
  if (isEmpty(tabs)) {
    return null;
  }

  return (
    <div className={classNames('payflow-ui tabs', className, `variant-${variant}`)}>
      <TabsPrimitive.Root className="tabs__root" defaultValue={tabs[0].id} value={value} onValueChange={onValueChange}>
        <TabsPrimitive.List className="tabs__list" aria-label={label}>
          {tabs.map((tab) => (
            <TabsPrimitive.Trigger
              className="tabs__trigger"
              value={tab.id}
              id={tab.id}
              key={tab.id}
              disabled={disableTabs}
              aria-disabled={disableTabs}
            >
              {tab.title}
            </TabsPrimitive.Trigger>
          ))}
        </TabsPrimitive.List>
        <div className="tabs__content-wrapper">
          {tabs.map((tab) => (
            <TabsPrimitive.Content
              className={classNames('tabs__content', disableContent && 'tabs__content_disabled')}
              value={tab.id}
              key={tab.id}
              aria-disabled={disableContent}
            >
              {tab.content}
              {disableContent && <div className="tabs__content_disable-div" />}
            </TabsPrimitive.Content>
          ))}
        </div>
      </TabsPrimitive.Root>
    </div>
  );
};
